import { useAppSelector } from 'hooks/reduxHooks'
import { getExperienceDatesKey } from 'lib/experiences/experienceUtils'

type DateParams = {
  redemptionLocationId?: string
  pickupPointId?: string
}

function useExperienceAvailableDates(experience: App.ExperienceOffer, params: DateParams) {
  const { redemptionLocationId } = params

  const experienceDates = useAppSelector(state => state.experience.experienceDates[experience.id])

  const pickupPointId = experience.pickupOptional ? undefined : params.pickupPointId
  const key = getExperienceDatesKey(experience.id, { pickupPointId, redemptionLocationId })

  return experienceDates?.[key]
}

export default useExperienceAvailableDates
